
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as aboutnkAkLFijnv8sMkMYpnQubcB4xweqAdqK4rrhQJe7am4Meta } from "/vercel/path0/src/pages/about.vue?macro=true";
import { default as indexjXfg20vSWiqV3Wel4ayAAWoFt0maAgUV4XGStNqb8sIMeta } from "/vercel/path0/src/pages/index.vue?macro=true";
import { default as privacy452y0786v5WbafKMXrTZSTsUAzASjMxXzy_45fGGLxtBcMeta } from "/vercel/path0/src/pages/privacy.vue?macro=true";
import { default as services_MpmDRqOBXNeH1U9AH4CLFPcUNJlYtzF1_45t3LlWNLhgMeta } from "/vercel/path0/src/pages/services.vue?macro=true";
import { default as indexHu3oLYSZNMf6SX_45Ah1WbPLYdA2ED3Kj8ZIL2YowpYksMeta } from "/vercel/path0/src/pages/cart/index.vue?macro=true";
import { default as indexJhb_45AyyZl5H9M12vla_45BAQ3EmuJVYRBHBZ3b8NEpnfwMeta } from "/vercel/path0/src/pages/shop/index.vue?macro=true";
import { default as merchC_456x1vKZ01m6mK_45gMwNF4RWhg1ugwrK6RiqTFCftP48Meta } from "/vercel/path0/src/pages/shop/merch.vue?macro=true";
import { default as index2sYxtsXwcsJ8VR9SCa75PCDTwYhb9Os6lOYVqaneD9wMeta } from "/vercel/path0/src/pages/posts/index.vue?macro=true";
import { default as _91slug_93ouHwNEqj275WOnaDG19Bk3gUFl0KKVLE3CPgTkI6TT8Meta } from "/vercel/path0/src/pages/shop/[slug].vue?macro=true";
import { default as _91slug_93DIru7tTPEv9JtwsxbkFr2zQb9lyeRgVdFFGRG1pZrL4Meta } from "/vercel/path0/src/pages/posts/[slug].vue?macro=true";
import { default as index_45mnImF0ZXYV_45i7x2K3JwiwzVC1WYumqdnI6jBB4wCKIMeta } from "/vercel/path0/src/pages/artists/index.vue?macro=true";
import { default as _91slug_93OAPQWNE1remXfv155IBaKmeOJ2FUkuvjyDFFsGDTAN4Meta } from "/vercel/path0/src/pages/artists/[slug].vue?macro=true";
import { default as indexm1omqa_45KWgNhU_FamRt1Remb8BQxifmCf3tkb4KVmQIMeta } from "/vercel/path0/src/pages/checkout/index.vue?macro=true";
import { default as indexRhjP6Dfj7wqGflB0W8Gwmm6I_45NO7vx6OHjpbZ7bi0TMMeta } from "/vercel/path0/src/pages/releases/index.vue?macro=true";
import { default as cassettesT8Ylq2Gyi8OR3UNp01T_2NFPyCHNUQZehSP8tnhoLHEMeta } from "/vercel/path0/src/pages/shop/cassettes.vue?macro=true";
import { default as wholesale_451H1d5ynsKhsR1F7l0ODFyEzFG_459KW6fEHdI4Ez_45usAMeta } from "/vercel/path0/src/pages/shop/wholesale.vue?macro=true";
import { default as _91slug_93RticFuggHqTeMLbrhYmIMQDH0A5hVl60U3A_KsTKTooMeta } from "/vercel/path0/src/pages/releases/[slug].vue?macro=true";
import { default as slug_45backupszZ5skEDtrikeKYbRMr9kORLesEP78MDZHyY1ejCLKgMeta } from "/vercel/path0/src/pages/shop/slug-backup.vue?macro=true";
import { default as order_45success7iAWVEozbX9_45dT89uwF7jVYYPkhQmgRzECvCsIyEhG4Meta } from "/vercel/path0/src/pages/shop/order-success.vue?macro=true";
import { default as merch_45bundlesXV3TkR1haMlgOqRqQYLBCE7MyC4f2PS4YuF5BJDlo9wMeta } from "/vercel/path0/src/pages/shop/tags/merch-bundles.vue?macro=true";
import { default as post_45rock_45t_45shirtsu7J4sR_45HojbyrXcI4l9Rf1uQa6SDP8pH_PwsQaNjrpIMeta } from "/vercel/path0/src/pages/shop/tags/post-rock-t-shirts.vue?macro=true";
import { default as post_45metal_45t_45shirtsWRSPgdKBnY07Gfpu4ZTtDKyM_Jfg9__DdmD4p0qzxeYMeta } from "/vercel/path0/src/pages/shop/tags/post-metal-t-shirts.vue?macro=true";
import { default as post_45rock_45cassettesEq5fQkaRTY4YEmgoXEevtn66IH1QZHebpeYEf5CRz6cMeta } from "/vercel/path0/src/pages/shop/tags/post-rock-cassettes.vue?macro=true";
import { default as post_45metal_45cassettesL314_45ZDxB0EWJcgnaeVwX6DWYU18DtVhjN2vfT_45ym4IMeta } from "/vercel/path0/src/pages/shop/tags/post-metal-cassettes.vue?macro=true";
import { default as black_45metal_45cassettesD3EaLY0fIoupn3aXBawhjyOEUZirRbnhzfwGqFky4DEMeta } from "/vercel/path0/src/pages/shop/tags/black-metal-cassettes.vue?macro=true";
export default [
  {
    name: "about",
    path: "/about",
    component: () => import("/vercel/path0/src/pages/about.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/vercel/path0/src/pages/index.vue")
  },
  {
    name: "privacy",
    path: "/privacy",
    component: () => import("/vercel/path0/src/pages/privacy.vue")
  },
  {
    name: "services",
    path: "/services",
    component: () => import("/vercel/path0/src/pages/services.vue")
  },
  {
    name: "cart",
    path: "/cart",
    component: () => import("/vercel/path0/src/pages/cart/index.vue")
  },
  {
    name: "shop",
    path: "/shop",
    component: () => import("/vercel/path0/src/pages/shop/index.vue")
  },
  {
    name: "shop-merch",
    path: "/shop/merch",
    component: () => import("/vercel/path0/src/pages/shop/merch.vue")
  },
  {
    name: "posts",
    path: "/posts",
    component: () => import("/vercel/path0/src/pages/posts/index.vue")
  },
  {
    name: "shop-slug",
    path: "/shop/:slug()",
    component: () => import("/vercel/path0/src/pages/shop/[slug].vue")
  },
  {
    name: "posts-slug",
    path: "/posts/:slug()",
    component: () => import("/vercel/path0/src/pages/posts/[slug].vue")
  },
  {
    name: "artists",
    path: "/artists",
    component: () => import("/vercel/path0/src/pages/artists/index.vue")
  },
  {
    name: "artists-slug",
    path: "/artists/:slug()",
    component: () => import("/vercel/path0/src/pages/artists/[slug].vue")
  },
  {
    name: "checkout",
    path: "/checkout",
    component: () => import("/vercel/path0/src/pages/checkout/index.vue")
  },
  {
    name: "releases",
    path: "/releases",
    component: () => import("/vercel/path0/src/pages/releases/index.vue")
  },
  {
    name: "shop-cassettes",
    path: "/shop/cassettes",
    component: () => import("/vercel/path0/src/pages/shop/cassettes.vue")
  },
  {
    name: "shop-wholesale",
    path: "/shop/wholesale",
    component: () => import("/vercel/path0/src/pages/shop/wholesale.vue")
  },
  {
    name: "releases-slug",
    path: "/releases/:slug()",
    meta: _91slug_93RticFuggHqTeMLbrhYmIMQDH0A5hVl60U3A_KsTKTooMeta || {},
    component: () => import("/vercel/path0/src/pages/releases/[slug].vue")
  },
  {
    name: "shop-slug-backup",
    path: "/shop/slug-backup",
    component: () => import("/vercel/path0/src/pages/shop/slug-backup.vue")
  },
  {
    name: "shop-order-success",
    path: "/shop/order-success",
    component: () => import("/vercel/path0/src/pages/shop/order-success.vue")
  },
  {
    name: "shop-tags-merch-bundles",
    path: "/shop/tags/merch-bundles",
    component: () => import("/vercel/path0/src/pages/shop/tags/merch-bundles.vue")
  },
  {
    name: "shop-tags-post-rock-t-shirts",
    path: "/shop/tags/post-rock-t-shirts",
    component: () => import("/vercel/path0/src/pages/shop/tags/post-rock-t-shirts.vue")
  },
  {
    name: "shop-tags-post-metal-t-shirts",
    path: "/shop/tags/post-metal-t-shirts",
    component: () => import("/vercel/path0/src/pages/shop/tags/post-metal-t-shirts.vue")
  },
  {
    name: "shop-tags-post-rock-cassettes",
    path: "/shop/tags/post-rock-cassettes",
    component: () => import("/vercel/path0/src/pages/shop/tags/post-rock-cassettes.vue")
  },
  {
    name: "shop-tags-post-metal-cassettes",
    path: "/shop/tags/post-metal-cassettes",
    component: () => import("/vercel/path0/src/pages/shop/tags/post-metal-cassettes.vue")
  },
  {
    name: "shop-tags-black-metal-cassettes",
    path: "/shop/tags/black-metal-cassettes",
    component: () => import("/vercel/path0/src/pages/shop/tags/black-metal-cassettes.vue")
  }
]